import { defineStyleConfig } from '@chakra-ui/system';

export const Heading = defineStyleConfig({
    variants: {
        header1: {
            fontFamily: 'TT Norms Pro',
            fontSize: '3rem',
            lineHeight: '4.5rem',
            letterSpacing: '0.0625rem',
        },

        header2: {
            fontFamily: 'TT Norms Pro',
            fontSize: '2.5rem',
            lineHeight: '3.75rem',
            letterSpacing: '0.0625rem',
        },

        header3: {
            fontFamily: 'TT Norms Pro',
            fontSize: '2rem',
            lineHeight: '3rem',
            letterSpacing: '0.0625rem',
        },

        header4: {
            fontFamily: 'TT Norms Pro',
            fontSize: '1.5rem',
            lineHeight: '2.25rem',
            letterSpacing: '0.0625rem',
        },
    },
});
